"use strict";
/* eslint-disable no-restricted-globals */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateTimeIntervalStringFromShift = exports.getTimezoneAbbreviation = exports.DayOfWeekMappings = exports.createDTDayInDefaultTZ = exports.getDateString = exports.getWeekIntervalStrings = exports.isTimeSameOrBefore = exports.datesRemainingInInterval = exports.areDatesEqual = exports.timeDifferenceWithDurationString = exports.getTimeDifferenceStr = exports.getTimeDifference = exports.formatTimeDifference = exports.getTimeString = exports.formatHoursAndMinutesFromKey = exports.trimISOStringMilliseconds = exports.getWeekIntervalDates = exports.getWeekIntervalString = exports.durationToHours = exports.formatTime = exports.getTimeDurationString = exports.getTimeIntervalStr = exports.formatDuration = exports.getDurationStr = exports.getDurationRangeStr = void 0;
var luxon_1 = require("luxon");
var atoz_shiftapp_types_1 = require("@amzn/atoz-shiftapp-types");
var i18next_1 = __importDefault(require("i18next"));
var atoz_shiftapp_metrics_1 = require("@amzn/atoz-shiftapp-metrics");
var getDurationRangeStr = function (durationRange) {
    var max = durationRange.max, min = durationRange.min;
    var maxDurationStr = getDurationStr(max);
    var minDurationStr = getDurationStr(min);
    return maxDurationStr === minDurationStr
        ? minDurationStr
        : "".concat(minDurationStr, " - ").concat(maxDurationStr);
};
exports.getDurationRangeStr = getDurationRangeStr;
function getDurationStr(duration, short) {
    // TODO: add checkValidity check with logging
    return formatDuration(luxon_1.Duration.fromISO(duration.value), short);
}
exports.getDurationStr = getDurationStr;
function formatDuration(duration, short) {
    var hourString = short
        ? i18next_1.default.t('ess_common_time_hour_short')
        : duration.hours === 1
            ? i18next_1.default.t('ess_common_time_hourAbbr_single')
            : i18next_1.default.t('ess_common_time_hourAbbr_plural');
    var minString = short
        ? i18next_1.default.t('ess_common_time_minuteAbbr_short')
        : duration.minutes === 1
            ? i18next_1.default.t('ess_common_time_minuteAbbr_single')
            : i18next_1.default.t('ess_common_time_minuteAbbr_plural');
    return "".concat(duration.hours).concat(hourString).concat(duration.minutes === 0 ? '' : " ".concat(duration.minutes).concat(minString));
}
exports.formatDuration = formatDuration;
function getTimeIntervalStr(startTime, endTime) {
    // TODO: add checkValidity check with logging
    var startTimeStr = formatTime(startTime);
    var endTimeStr = formatTime(endTime);
    return "".concat(startTimeStr, "-").concat(endTimeStr);
}
exports.getTimeIntervalStr = getTimeIntervalStr;
var getTimeDurationString = function (date1, date2) {
    if (!date1 || !date2)
        return undefined;
    var diff = date1
        .toUTC()
        .diff(date2)
        .shiftTo('days', 'hours', 'minutes', 'seconds');
    var days = Math.trunc(diff.days);
    var minutes = Math.trunc(diff.minutes);
    var hours = Math.trunc(diff.hours);
    var seconds = Math.trunc(diff.seconds);
    if (days >= 7) {
        return "".concat(days, " ").concat(i18next_1.default.t('ess_common_time_dayAbbr'));
    }
    else if (days >= 1) {
        return "".concat(days, " ").concat(i18next_1.default.t('ess_common_time_dayAbbr'), " ").concat(hours, " ").concat(i18next_1.default.t('ess_common_time_hour_short'));
    }
    else if (hours >= 1) {
        return "".concat(hours, " ").concat(i18next_1.default.t('ess_common_time_hour_short'), " ").concat(minutes + (seconds ? 1 : 0), " ").concat(i18next_1.default.t('ess_common_time_minuteAbbr_optional'));
    }
    else if (minutes >= 1) {
        return "".concat(minutes + (seconds ? 1 : 0), " ").concat(i18next_1.default.t('ess_common_time_minuteAbbr_optional'));
    }
    else {
        return "".concat(seconds < 0 ? 0 : seconds, " ").concat(i18next_1.default.t('ess_common_time_seconds'));
    }
};
exports.getTimeDurationString = getTimeDurationString;
function formatTime(dateTime) {
    return dateTime
        .setLocale(luxon_1.Settings.defaultLocale)
        .toFormat('t')
        .replace(' ', '')
        .toLowerCase();
}
exports.formatTime = formatTime;
function durationToHours(isoDuration) {
    return luxon_1.Duration.fromISO(isoDuration).as('hours');
}
exports.durationToHours = durationToHours;
/**
 * Get Sunday to Saturday for the current week since this is the range we calculate hours cap for the week
 * E.g., if today is Apr 20 (Monday), then getWeekIntervalString(Apr 20) will return 4/19 - 4/25
 */
function getWeekIntervalString(date) {
    // TODO: add checkValidity check with logging. Add luxon localization support
    var _a = getWeekIntervalDates(date), weekStart = _a.weekStart, weekEnd = _a.weekEnd;
    var sunday = weekStart.toLocaleString({
        month: 'short',
        day: 'numeric'
    });
    var saturday = weekEnd.toLocaleString({
        month: 'short',
        day: 'numeric'
    });
    return "".concat(sunday, " - ").concat(saturday);
}
exports.getWeekIntervalString = getWeekIntervalString;
/**
 * Returns the start and end DateTimes for the week interval (Sunday - Saturday) of the given date
 * @param date
 */
function getWeekIntervalDates(date) {
    // TODO: add checkValidity check with logging
    var weekdayOfDate = date.weekday === 7 ? 0 : date.weekday;
    var weekStart = date.minus({ days: weekdayOfDate }).startOf('day');
    var weekEnd = date.plus({ days: 6 - weekdayOfDate }).endOf('day');
    var weekInterval = luxon_1.Interval.fromDateTimes(weekStart, weekEnd);
    return { weekStart: weekStart, weekEnd: weekEnd, weekInterval: weekInterval };
}
exports.getWeekIntervalDates = getWeekIntervalDates;
/**
 * Converts a DateTime instance to a ISO string, minus the milliseconds.
 * This is a standard ISO string: '1982-05-25T00:00:00.000Z'
 * This function mutates that into: '1982-05-25T00:00:00Z'
 */
function trimISOStringMilliseconds(dateTime) {
    return dateTime
        .toUTC()
        .set({ millisecond: 0 })
        .toISO({ suppressMilliseconds: true });
}
exports.trimISOStringMilliseconds = trimISOStringMilliseconds;
var getHours = function (time) {
    return Math.floor(time);
};
var getMinutes = function (time) {
    return Math.round((time % 1) * 60);
};
var formatHoursAndMinutesFromKey = function (translationKeyBase, time) {
    var hours = getHours(time);
    var minutes = getMinutes(time);
    if (hours > 0 && minutes > 0) {
        return "".concat(i18next_1.default.t(translationKeyBase, {
            hours: hours,
            minutes: minutes
        }));
    }
    else if (hours > 0 && minutes <= 0) {
        return "".concat(i18next_1.default.t(translationKeyBase + 'NoMinutes', {
            hours: hours
        }));
    }
    else if (hours <= 0 && minutes > 0) {
        return "".concat(i18next_1.default.t(translationKeyBase + 'NoHours', {
            minutes: minutes
        }));
    }
    else {
        return "".concat(i18next_1.default.t(translationKeyBase + 'NoMinutes', {
            hours: hours
        }));
    }
};
exports.formatHoursAndMinutesFromKey = formatHoursAndMinutesFromKey;
/**
 * get time string in 12hr or 24hr format
 * E.g., getTimeString(Wed Apr 15 2020 19:00, true) return 19:00
 * E.g., getTimeString(Wed Apr 15 2020 19:00, false) return 7:00 pm
 */
var getTimeString = function (date, militaryTime) {
    // TODO: add checkValidity check with logging
    return militaryTime
        ? date.toLocaleString(luxon_1.DateTime.TIME_24_SIMPLE)
        : date.toLocaleString(luxon_1.DateTime.TIME_SIMPLE);
};
exports.getTimeString = getTimeString;
/**
 * Get Time difference String from DurationObject
 * E.g., getTimeDifferenceStr(Wed Apr 15 2020 19:00, Wed Apr 15 2020 21:00) will return 2 hrs
 *
 */
var formatTimeDifference = function (timeDifference, short) {
    var hourString = short
        ? i18next_1.default.t('ess_common_time_hour_short')
        : i18next_1.default.t('ess_common_time_hourAbbr_plural');
    var minString = short
        ? i18next_1.default.t('ess_common_time_minuteAbbr_short')
        : i18next_1.default.t('ess_common_time_minuteAbbr_plural');
    return "".concat(timeDifference.hours).concat(hourString).concat(timeDifference.minutes === 0
        ? ''
        : " ".concat(timeDifference.minutes).concat(minString));
};
exports.formatTimeDifference = formatTimeDifference;
/**
 * Get Time difference duration
 * E.g., getTimeDifference(Wed Apr 15 2020 19:00, Wed Apr 15 2020 21:00) will return 2 hrs
 *
 */
function getTimeDifference(startTime, endTime) {
    // TODO: add checkValidity check with logging
    return endTime.diff(startTime, ['hours', 'minutes', 'seconds']);
}
exports.getTimeDifference = getTimeDifference;
/**
 * Get Time difference String
 * E.g., getTimeDifferenceStr(Wed Apr 15 2020 19:00, Wed Apr 15 2020 21:00) will return 2 hrs
 *
 */
function getTimeDifferenceStr(startTime, endTime, short) {
    // TODO: add checkValidity check with logging
    var differenceStr = getTimeDifference(startTime, endTime).toObject();
    return (0, exports.formatTimeDifference)(differenceStr, short);
}
exports.getTimeDifferenceStr = getTimeDifferenceStr;
/**
 * Get Time difference String that includes duration
 * E.g., timeDifferenceWithDurationString(Wed Apr 15 2020 19:00, Wed Apr 15 2020 21:00)
 * will return 7:00 PM-9:00 PM (2hrs)
 *
 */
var timeDifferenceWithDurationString = function (startTime, endTime, militaryTime) {
    return ("".concat((0, exports.getTimeString)(startTime, militaryTime || false), "-") +
        "".concat((0, exports.getTimeString)(endTime, militaryTime || false)) +
        "".concat(' ') +
        "(".concat(getTimeDifferenceStr(startTime, endTime), ")"));
};
exports.timeDifferenceWithDurationString = timeDifferenceWithDurationString;
/**
 * Compare if two dates without time are equal
 * E.g., Wed Apr 15 2020 19:00 is equal to Wed Apr 15 2020 11:00
 */
var areDatesEqual = function (date1, date2) {
    // TODO: add checkValidity check with logging
    return (date1.day === date2.day &&
        date1.month === date2.month &&
        date1.year === date2.year);
};
exports.areDatesEqual = areDatesEqual;
/**
 * Given an Interval and a DateTime that is within the Interval, determine the DateTimes that occur
 * on or after that date in the given Interval
 * @param startDate Date within the Interval
 * @param interval Luxon Interval
 * @returns Array of DateTimes that are after the startDate in the Interval
 */
var datesRemainingInInterval = function (startDate, interval) {
    if (!interval.contains(startDate)) {
        return [];
    }
    return interval
        .set({ start: startDate })
        .splitBy({ days: 1 })
        .map(function (dayInterval) { return dayInterval.start.startOf('day'); });
};
exports.datesRemainingInInterval = datesRemainingInInterval;
/**
 * Compare the time portion of two moment objects
 * E.g., isTimeSameOrBefore(3:00 am, 3:00pm) return true
 * E.g., isTimeSameOrBefore(3:00 pm, 3:00am) return false
 * E.g., isTimeSameOrBefore(3:00 pm, 3:00pm) return true
 * E.g., isTimeSameOrBefore(undefined, 3:00pm) return true
 */
var isTimeSameOrBefore = function (time1, time2) {
    if (!time1 || !time2) {
        return true;
    }
    // TODO: add checkValidity check with logging
    var time1Min = time1.minute + time1.hour * 60;
    var time2Min = time2.minute + time2.hour * 60;
    return time1Min <= time2Min;
};
exports.isTimeSameOrBefore = isTimeSameOrBefore;
/**
 * get specified number of week intervals
 */
var getWeekIntervalStrings = function (total) {
    var weekIntervals = [];
    for (var i = 0; i < total; i++) {
        weekIntervals.push(getWeekIntervalString(luxon_1.DateTime.local().plus({ week: i })));
    }
    return weekIntervals;
};
exports.getWeekIntervalStrings = getWeekIntervalStrings;
/**
 * Converts Date object obtained from AtoZDatepicker to "yyyy-MM-dd" string.
 * Thu Feb 04 2021 00:00:00 GMT-0800 (Pacific Standard Time) -> 2021-02-04
 * Thu Feb 04 2021 00:00:00 GMT+0800 (Irkutsk Standard Time) -> 2021-02-04
 */
function getDateString(day) {
    if (day instanceof luxon_1.DateTime) {
        return luxon_1.DateTime.fromObject({
            year: day.year,
            month: day.month,
            day: day.day
        }).toISODate();
    }
    return luxon_1.DateTime.fromObject({
        year: day.getFullYear(),
        month: day.getMonth() + 1,
        day: day.getDate()
    }).toISODate();
}
exports.getDateString = getDateString;
/**
 * Creates DateTime with default timezone using year, month, day of JS Date.
 * Used to convert day selected in AtoZDatepicker to the DateTime, which is used for pulling AA data in order to display it on that day, regardless of the browser TZ.
 * Thu Feb 04 2021 00:00:00 GMT-0800 (Pacific Standard Time) -> 2021-02-04T00:00:00.000-08:00
 * Thu Feb 04 2021 00:00:00 GMT+0800 (Irkutsk Standard Time) -> 2021-02-04T00:00:00.000-08:00
 */
function createDTDayInDefaultTZ(day) {
    if (!luxon_1.DateTime.fromJSDate(day).isValid) {
        return luxon_1.DateTime.fromJSDate(day);
    }
    return luxon_1.DateTime.fromFormat(getDateString(day), 'y-MM-dd');
}
exports.createDTDayInDefaultTZ = createDTDayInDefaultTZ;
/**
 * Get the day of the week from string like 'Fri'
 * @returns the day of the week
 */
exports.DayOfWeekMappings = {
    Sun: atoz_shiftapp_types_1.DayOfWeek.Sun,
    Mon: atoz_shiftapp_types_1.DayOfWeek.Mon,
    Tue: atoz_shiftapp_types_1.DayOfWeek.Tue,
    Wed: atoz_shiftapp_types_1.DayOfWeek.Wed,
    Thu: atoz_shiftapp_types_1.DayOfWeek.Thu,
    Fri: atoz_shiftapp_types_1.DayOfWeek.Fri,
    Sat: atoz_shiftapp_types_1.DayOfWeek.Sat
};
/**
 * Convert a timezone string to its corresponding abbreviation. e.g: input 'America/Los_Angeles'; output 'PST'
 *
 * Warning: In CLDR, many names and abbreviations are designated as being specific to a given locale, rather than
 * being used worldwide. The same thing happens with Europe/London getting GMT+1 instead of BST unless the locale
 * is en-GB.
 *
 * Reference:
 * https://stackoverflow.com/questions/62019992/detect-timezone-abbreviation-using-luxon/70672604
 * https://github.com/tc39/proposal-temporal/issues/2257
 */
var getTimezoneAbbreviation = function (timezone) {
    try {
        if (!luxon_1.IANAZone.isValidZone(timezone)) {
            throw Error("".concat(timezone, " is not a real timezone."));
        }
        return luxon_1.DateTime.fromJSDate(new Date(), {
            zone: timezone
        }).toFormat('ZZZZ');
    }
    catch (error) {
        atoz_shiftapp_metrics_1.logger.error('Caught error in getTimezoneAbbreviation', error.toString());
    }
};
exports.getTimezoneAbbreviation = getTimezoneAbbreviation;
var getDateTimeIntervalStringFromShift = function (startTime, endTime) {
    var monthStr = startTime
        .setLocale(luxon_1.Settings.defaultLocale)
        .toLocaleString({ month: 'long' });
    var durationStr = "(".concat(formatDuration(endTime.diff(startTime, ['hours', 'minutes', 'seconds'])), ")");
    var startEndTimeStr = "".concat(monthStr, " ").concat(startTime.day, ", ").concat(formatTime(startTime), " - ").concat(formatTime(endTime), " ").concat(durationStr);
    return startEndTimeStr;
};
exports.getDateTimeIntervalStringFromShift = getDateTimeIntervalStringFromShift;
